var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvancedAr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3724 35.023C40.1148 37.2836 40.8108 39.4409 41.5416 41.5867C42.8408 45.3734 45.4973 47.2897 49.5341 47.3127C54.5221 47.3356 59.5101 47.3356 64.4981 47.3127C68.5349 47.2897 71.1681 45.3964 72.4789 41.5867C73.2213 39.4409 73.9057 37.295 74.6481 35.0689C77.1537 35.0689 79.6245 34.9197 82.0722 35.1033C85.9118 35.3787 88.9626 38.672 88.9858 42.5391C89.0438 54.1059 89.0206 65.6726 88.9626 77.2394C88.9626 77.8017 88.3826 78.4558 87.8954 78.8803C87.3966 79.3164 86.7006 79.5229 86.0858 79.8442C84.8214 80.5213 84.427 81.6114 84.9722 82.8622C85.5058 84.0785 86.5962 84.3769 87.8606 84.0211C88.1854 83.9293 88.4986 83.8146 88.9162 83.6769V116.323C88.4058 116.186 87.9418 116.036 87.4662 115.945C86.3062 115.749 85.2042 116.151 85.007 117.241C84.8562 118.079 85.4246 119.054 85.703 119.961C85.7378 120.087 85.9698 120.19 86.1322 120.225C88.8582 120.902 89.0786 122.818 89.0554 125.239C88.9394 135.67 89.009 146.101 88.9974 156.543C88.9974 161.879 85.8422 165 80.4597 165C64.8113 165 49.1513 165 33.5028 165C28.2248 165 25 161.856 25 156.669C25 118.905 25 81.1409 25 43.3768C25 38.1671 28.2132 35.0345 33.5028 35.023C35.3936 35.023 37.2844 35.023 39.3724 35.023ZM56.9465 155.763C59.5797 155.763 62.2129 155.774 64.8461 155.763C66.8413 155.751 68.0013 154.845 67.9549 153.387C67.9085 151.976 66.8297 151.138 64.8925 151.138C59.6261 151.115 54.3597 151.115 49.1049 151.138C47.1793 151.138 46.1005 151.999 46.0773 153.422C46.0657 154.845 47.1677 155.74 49.0469 155.751C51.6801 155.774 54.3133 155.751 56.9465 155.751V155.763ZM54.0233 103.758C56.5173 103.815 57.1205 102.45 57.0161 98.4567C56.9813 97.1944 55.9489 96.1961 54.6845 96.242C54.4061 96.242 54.0929 96.2879 53.8493 96.4026C52.7241 96.9649 51.5641 97.4698 50.5201 98.1583C49.3485 98.9386 48.9425 100.304 49.9517 101.211C51.2509 102.393 52.9677 103.127 54.0117 103.758H54.0233ZM66.5861 89.7357C64.7765 90.8258 63.0945 91.652 61.6909 92.7995C61.2733 93.1437 61.3429 94.624 61.7489 95.1978C62.1549 95.7715 63.3845 96.2764 64.0457 96.0813C65.4377 95.6797 66.8065 94.9568 67.9317 94.0617C68.4653 93.6257 68.7321 92.3979 68.5349 91.6864C68.3377 90.9864 67.3981 90.493 66.5861 89.7357ZM68.7321 107.224C68.6393 107.028 68.5697 106.363 68.2217 106.156C66.7833 105.284 65.3101 104.366 63.7209 103.884C63.1525 103.712 61.8301 104.561 61.5517 105.227C61.2733 105.892 61.5749 107.235 62.1317 107.705C63.1757 108.601 64.5445 109.197 65.8553 109.691C67.3053 110.241 68.7553 109.06 68.7321 107.224ZM73.0589 87.28C72.8269 89.3341 74.4277 90.6307 76.0633 90.0225C77.2349 89.5865 78.3485 88.9783 79.4157 88.3243C80.5525 87.6243 80.8077 86.4997 80.2045 85.3522C79.5897 84.1818 78.4993 83.849 77.2697 84.3769C76.1677 84.8473 75.0889 85.3867 74.0913 86.0407C73.5693 86.385 73.2561 87.0391 73.0589 87.28ZM75.2165 109.415C74.4045 110.115 73.4649 110.54 73.2793 111.182C73.0589 111.917 73.2213 113.191 73.7317 113.604C74.9149 114.533 76.3417 115.268 77.7917 115.704C78.4297 115.887 79.6709 115.336 80.0421 114.751C80.4249 114.154 80.4249 112.686 79.9841 112.33C78.6153 111.217 76.9565 110.448 75.2165 109.427V109.415Z",
    fill: "url(#paint0_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.092 62.001V64.4337C156.092 87.6131 156.046 110.781 156.162 133.961C156.173 136.382 155.466 137.564 153.261 138.493C149.758 139.973 146.394 141.798 142.763 143.588C142.705 142.877 142.636 142.406 142.636 141.936C142.636 117.964 142.636 94.0047 142.613 70.0335C142.613 68.9433 142.879 68.3122 143.935 67.8188C147.496 66.1434 151.011 64.3533 154.538 62.6206C154.978 62.4026 155.442 62.2649 156.092 62.0125V62.001Z",
    fill: "url(#paint1_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.308 61.8975C128.67 64.0548 132.776 66.0285 136.824 68.1398C137.288 68.3808 137.602 69.3218 137.602 69.9529C137.66 76.7002 137.636 83.4475 137.636 90.1947C137.636 107.201 137.636 124.218 137.636 141.224V143.416C137.08 143.255 136.697 143.198 136.36 143.037C132.672 141.224 129.006 139.365 125.294 137.586C124.378 137.15 124.099 136.6 124.099 135.624C124.122 111.584 124.122 87.544 124.122 63.504C124.122 63.045 124.215 62.586 124.296 61.9089L124.308 61.8975Z",
    fill: "url(#paint2_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2561 35.0918H69.7646C69.0454 37.1917 68.5698 39.2572 67.5954 41.0588C67.1314 41.9079 65.7162 42.6997 64.707 42.7227C59.5565 42.8833 54.3945 42.8145 49.2325 42.7915C47.8753 42.7915 46.7269 42.2063 46.2281 40.9096C45.5205 39.0736 44.9521 37.1802 44.2445 35.1033L44.2561 35.0918Z",
    fill: "url(#paint3_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.254 57.8584C131.651 55.6782 135.618 53.6815 139.62 51.7537C139.956 51.5931 140.536 51.6849 140.896 51.8685C144.701 53.716 148.482 55.6093 152.264 57.4912C152.392 57.5601 152.473 57.7207 152.728 57.9847C151.44 58.6387 150.246 59.2584 149.039 59.8551C147.404 60.6698 145.64 61.2894 144.144 62.3107C141.43 64.1582 139.005 64.1238 136.198 62.3681C133.518 60.6813 130.525 59.4764 127.254 57.8584Z",
    fill: "url(#paint4_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.924 151.987C112.708 151.987 115.271 151.976 117.835 151.987C119.772 151.999 120.851 152.825 120.851 154.236C120.851 155.648 119.749 156.497 117.847 156.508C114.587 156.52 111.316 156.531 108.056 156.508C106.142 156.497 105.295 155.717 105.272 153.835C105.226 150.496 105.226 147.156 105.272 143.806C105.295 142.107 106.142 141.178 107.534 141.143C108.984 141.109 109.889 142.096 109.912 143.852C109.947 146.456 109.912 149.05 109.912 151.964L109.924 151.987Z",
    fill: "url(#paint5_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.924 43.1706C109.924 45.7409 109.924 48.0589 109.924 50.3654C109.924 50.8703 109.959 51.3981 109.877 51.8915C109.669 53.1653 108.891 53.98 107.569 53.98C106.247 53.98 105.342 53.1653 105.319 51.8686C105.237 48.1851 105.226 44.5016 105.319 40.8297C105.342 39.4527 106.258 38.6494 107.685 38.6379C111.293 38.615 114.9 38.6035 118.508 38.6379C119.935 38.6494 120.747 39.4641 120.839 40.8526C120.932 42.1149 119.877 43.1247 118.392 43.1476C115.654 43.1935 112.917 43.1591 109.924 43.1591V43.1706Z",
    fill: "url(#paint6_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.988 148.889C174.988 150.587 175.023 152.285 174.988 153.984C174.942 155.648 174.107 156.485 172.425 156.497C168.933 156.531 165.442 156.531 161.95 156.497C160.372 156.474 159.491 155.613 159.479 154.259C159.468 152.917 160.349 152.033 161.915 151.999C164.258 151.941 166.613 151.93 168.956 151.999C170.105 152.033 170.453 151.62 170.43 150.53C170.372 148.327 170.395 146.112 170.43 143.897C170.453 142.073 171.276 141.132 172.738 141.155C174.188 141.166 174.988 142.142 175.012 143.955C175.035 145.596 175.012 147.236 175.012 148.877L174.988 148.889Z",
    fill: "url(#paint7_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.383 43.1812C167.553 43.1812 164.978 43.1812 162.402 43.1812C160.43 43.1812 159.444 42.3894 159.444 40.8862C159.444 39.3944 160.419 38.6371 162.426 38.6256C165.639 38.6027 168.84 38.6027 172.054 38.6256C174.2 38.6486 174.965 39.3944 174.977 41.4829C175 44.7073 175 47.9433 174.977 51.1678C174.977 52.9005 174.072 53.9906 172.703 54.0136C171.311 54.0365 170.418 52.9923 170.395 51.2251C170.36 48.5744 170.395 45.9352 170.395 43.1697L170.383 43.1812Z",
    fill: "url(#paint8_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.446 72.5459C109.622 71.7886 108.625 71.3066 108.462 70.6181C108.277 69.8493 108.578 68.5985 109.147 68.1166C110.202 67.233 111.559 66.5675 112.905 66.2003C113.578 66.0167 114.796 66.4757 115.213 67.0379C115.631 67.6002 115.724 69.1034 115.318 69.4362C113.926 70.6066 112.244 71.4328 110.446 72.5459Z",
    fill: "url(#paint9_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.434 127.466C112.244 128.567 113.914 129.394 115.318 130.553C115.724 130.897 115.619 132.343 115.237 132.962C114.889 133.513 113.694 134.041 113.091 133.857C111.652 133.41 110.225 132.698 109.042 131.78C108.509 131.367 108.253 130.105 108.462 129.405C108.671 128.705 109.611 128.223 110.434 127.466Z",
    fill: "url(#paint10_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.031 74.9101C103.567 75.3347 102.906 76.2757 102.001 76.7232C100.621 77.4002 99.2982 78.9379 97.4886 77.7215C96.143 76.815 96.1198 74.8872 97.4886 74.0151C98.579 73.3151 99.7506 72.6955 100.969 72.2365C102.419 71.6857 103.95 72.7873 104.031 74.9101Z",
    fill: "url(#paint11_linear_108_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.019 125.239C103.985 127.27 102.384 128.348 100.841 127.74C99.681 127.281 98.5674 126.685 97.5117 126.031C96.3633 125.319 96.1777 124.229 96.8042 123.093C97.4306 121.968 98.4282 121.521 99.6926 122.106C100.725 122.588 101.792 123.024 102.709 123.667C103.347 124.114 103.741 124.895 104.019 125.239Z",
    fill: "url(#paint12_linear_108_585)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_585",
    x1: 57.0284,
    y1: 35.0117,
    x2: 57.0284,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_108_585",
    x1: 149.387,
    y1: 62.001,
    x2: 149.387,
    y2: 143.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_108_585",
    x1: 130.87,
    y1: 61.8975,
    x2: 130.87,
    y2: 143.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_108_585",
    x1: 57.0045,
    y1: 35.0918,
    x2: 57.0045,
    y2: 42.8259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_108_585",
    x1: 139.991,
    y1: 51.6709,
    x2: 139.991,
    y2: 63.6906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_108_585",
    x1: 113.044,
    y1: 141.143,
    x2: 113.044,
    y2: 156.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_108_585",
    x1: 113.049,
    y1: 38.6162,
    x2: 113.049,
    y2: 53.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_108_585",
    x1: 167.25,
    y1: 141.154,
    x2: 167.25,
    y2: 156.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_108_585",
    x1: 167.219,
    y1: 38.6084,
    x2: 167.219,
    y2: 54.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_108_585",
    x1: 111.993,
    y1: 66.1592,
    x2: 111.993,
    y2: 72.5459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_108_585",
    x1: 111.983,
    y1: 127.466,
    x2: 111.983,
    y2: 133.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_108_585",
    x1: 100.251,
    y1: 72.0957,
    x2: 100.251,
    y2: 78.1756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_108_585",
    x1: 100.235,
    y1: 121.849,
    x2: 100.235,
    y2: 127.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 130,
    fill: "white",
    transform: "translate(25 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedAr);
export default __webpack_public_path__ + "static/media/Advanced_AR.0b521b992bc9eca2df1da66275996e31.svg";
export { ForwardRef as ReactComponent };